import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinimize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"minimize, window, layout"} maskId="square-filled-radius-0-stroke-1-IconMinimize"><path d="M12 13V22H2V13H12Z" fill="currentColor"/><path d="M22 3V16H14.25V15H21V4H4V10.75H3V3H22Z" fill="currentColor"/><path d="M13 12V8.00001H14V10.2929L17.25 7.04291L17.9571 7.75001L14.7071 11H17V12H13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMinimize;
